var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import browserImageSize from "browser-image-size";
import ErrorText from "@irati/ui/src/ErrorText";
import Loading from "@irati/ui/src/Loading";
import add_a_file from "@irati/ui/images/add-a-file.png";
import getBase64 from "@irati/utils/images/getBase64";
import { injectIntl } from "@irati/utils/lang";
import { uploadImage } from "@irati/images/services/image";
import Flex from "@irati/ui/src/Flex";
import { Body, Label } from "@irati/ui/src/Typography";
import { StyledDropzone, StyledFormGroup, StyledUploadIcon, UploadedImage } from "./styled";
var ImageUploader = /** @class */ (function (_super) {
    __extends(ImageUploader, _super);
    function ImageUploader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.handleUpload = function (file) {
            return uploadImage(file).then(function (uploadedImageURL) {
                _this.props.onUploadSuccess(uploadedImageURL);
            });
        };
        _this.handleDrop = function (acceptedFile, rejectedFile) {
            var formatMessage = _this.props.formatMessage;
            if (rejectedFile.length > 0) {
                return _this.setState({
                    uploadError: formatMessage({
                        id: "platform.fields.imageUploader.dimensionsError"
                    })
                });
            }
            var acceptedFileImage = acceptedFile[0];
            getBase64(acceptedFileImage).then(function (base64Image) {
                var load = browserImageSize(base64Image).then(function () {
                    return _this.handleUpload(base64Image);
                });
                _this.setState({ load: load, uploadError: undefined });
            });
        };
        return _this;
    }
    ImageUploader.prototype.render = function () {
        var _a = this.props, error = _a.error, imageUrl = _a.imageUrl, help = _a.help, message = _a.message;
        var _b = this.state, load = _b.load, uploadError = _b.uploadError;
        return (React.createElement(StyledFormGroup, null,
            React.createElement(StyledDropzone, { accept: "image/jpg,image/jpeg,image/png", onDrop: this.handleDrop, hasError: !!error },
                load && (React.createElement(Flex, null,
                    React.createElement(Loading, { load: load }))),
                uploadError && React.createElement(ErrorText, null, uploadError),
                !load && !uploadError && !imageUrl && (React.createElement(React.Fragment, null,
                    React.createElement(StyledUploadIcon, { src: add_a_file, height: 80, alt: "add_a_file" }),
                    React.createElement(Label, { display: "block", marginBottom: 1 }, message),
                    React.createElement(Body, { textAlign: "center" }, help))),
                imageUrl && React.createElement(UploadedImage, { src: imageUrl }))));
    };
    return ImageUploader;
}(Component));
export default injectIntl(ImageUploader);
